module.exports = __webpack_public_path__ + "img/sp1.671fe728.png";